module.exports = __webpack_public_path__ + "static/img/banner_new2.e5667b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/banner/banner_new2.jpg
// module id = Aibh
// module chunks = 0